import {Checkbox, Space} from "antd";
import {Controller, useFormContext} from "react-hook-form";
import {FormFieldError} from "../../../../../design-system/form-field";

export function StoreServiceContentUploadConsentFormField() {
  const {control} = useFormContext<{consent: boolean}>();
  return (
    <div>
      <Controller
        control={control}
        name="consent"
        render={({field: {onChange, value, ref}, fieldState: {error}}) => (
          <Space size={16} direction="vertical" style={{display: "flex"}}>
            <Checkbox
              onChange={(e) => onChange(e.target.checked)}
              ref={ref}
              checked={value}
              // disabled={isDisabled}
            >
              I confirm that I am responsible for delivering this service and agree to
              Coachli's{" "}
              <a
                href="https://www.coachli.co/home/terms"
                target="_blank"
                rel="noreferrer"
              >
                Terms of Service
              </a>
            </Checkbox>
            <FormFieldError errorMessage={error?.message} />
          </Space>
        )}
      />
    </div>
  );
}
